import { DotLottie, DotLottieReact } from '@lottiefiles/dotlottie-react'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { View } from '@ds'
import { useHowler } from '@shared'
import { NarratorOverlayData, usePrologueActions } from '@store'

import styles from './NarratorOverlay.module.scss'

export const NarratorOverlay = ({
  text,
  onClose,
  soundPhrase,
}: NarratorOverlayData['payload']) => {
  const [_, setDotLottie] = useState<DotLottie | null>(null)
  const [data, setData] = useState<string>()
  const { setUserProgressVisible, setTapsVisible } = usePrologueActions()
  const { t } = useTranslation()

  const { audio } = useHowler({
    src: soundPhrase ?? '',
    volume: 1,
    html5: true,
    preload: true,
  })

  useEffect(() => {
    fetch('/lottie/particles_for_text.json')
      .then((res) => res.json())
      .then((data) => {
        setData(data)
      })
  }, [])

  useEffect(() => {
    setUserProgressVisible(false)
    setTapsVisible(false)
  }, [])

  useEffect(() => {
    if (!audio) return

    audio.stop()
    audio.play()

    return () => {
      audio.stop()
    }
  }, [audio])

  return (
    <View fadeIn className={styles.container} onClick={onClose}>
      <div className={styles.wrapper}>
        <div className={styles.animation}>
          <DotLottieReact
            data={data}
            dotLottieRefCallback={setDotLottie}
            autoplay
            loop
          />
        </div>
        <div className={styles.text}>{t(text)}</div>
        <div className={styles.animation2}>
          <DotLottieReact
            data={data}
            dotLottieRefCallback={setDotLottie}
            autoplay
            loop
          />
        </div>
      </div>
    </View>
  )
}
